/* eslint-disable no-unused-vars */

import React from 'react';
import { connect } from 'react-redux';
import ReactToPrint from 'react-to-print';
import moment from 'moment';

import { selectCurrentSalonCurrency } from 'selectors/currentSalon.selectors';

import ComponentToPrint from 'reports/Common/ComponentToPring';
import ProductSales from 'reports/RetailReport/ProductSales';
import ProductSalesByStylist from 'reports/RetailReport/ProductSalesByStylist';
import RetailPerformanceTable from 'reports/RetailReport/RetailPerformanceTable';
import { calculateTotalsOnProductSalesData, calculateTotalsOnServiceSalesData } from 'reports/sales.bl';
import { convertStylistsMapsToStylistTableData } from 'reports/utils';
const ReportsProps = ['salesReport', 'productSalesReport', 'productSalesByStylistReport'];

class RetailLayout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.componentRef = React.createRef();
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  checkIfAllDataIsLoaded = () => ReportsProps.every((prop) => this.props[prop].lastRequestResponse);

  render() {
    let revenueData;
    const currencyAbbr = this.props.currency;

    if (this.checkIfAllDataIsLoaded()) {
      const stylistGroup = this.props.salesReport.lastRequestResponse.stylist_group;

      const nameServicesTotalPriceMap = {};
      stylistGroup.forEach((stylist) => {
        nameServicesTotalPriceMap[stylist.name] = calculateTotalsOnServiceSalesData(stylist.services);
      });
      const nameProductsTotalPriceMap = {};
      stylistGroup.forEach((stylist) => {
        nameProductsTotalPriceMap[stylist.name] = calculateTotalsOnProductSalesData(stylist.products);
      });

      revenueData = convertStylistsMapsToStylistTableData(
        nameServicesTotalPriceMap,
        nameProductsTotalPriceMap,
        currencyAbbr,
      );
    }
    return (
      <div className="has-protipbox">
        <div className="new-wraper">
          <div className="performance p1 box retail">
            {!this.checkIfAllDataIsLoaded() && (
              <div className="spinner-container">
                <div className="load-spinner" />
              </div>
            )}
            {this.checkIfAllDataIsLoaded() && revenueData && (
              <React.Fragment>
                <div className="banner default full-width">
                  <div style={{ width: '100%' }}>
                    <div className="cfix relative">
                      <span className="img-emoji-1" role="img" aria-labelledby="lamp">
                        💡
                      </span>
                      <div className="text">
                        <strong>Pro tip:</strong>
                        You’ll need to use checkout for these reports to function correctly
                      </div>
                    </div>
                    <div className="cfix relative">
                      <span className="img-emoji-2" role="img" aria-labelledby="lamp">
                        💡
                      </span>
                      <div className="text">
                        <strong>Pro tip:</strong>
                        To add/manage retail products, head to Stock Management
                      </div>
                    </div>
                  </div>
                  <div className="link">
                    <a
                      href="https://help.getslick.com/en/articles/2732392-how-to-add-retail-technical-products-using-the-slick-stock-scanner-app"
                      alt="Heed help"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Need Help?
                    </a>
                    <ReactToPrint
                      trigger={() => <button className="btn-print-pdf-reports">Print PDF</button>}
                      content={() => this.componentRef.current}
                    />
                  </div>
                </div>
                <div style={{ marginTop: '18px' }} />
                <ComponentToPrint ref={this.componentRef} componentRef>
                  <RetailPerformanceTable
                    startDate={moment(this.props.uniqueVisitsReport.start_date).format('D MMM YYYY')}
                    endDate={moment(this.props.uniqueVisitsReport.end_date).format('D MMM YYYY')}
                    revenueData={revenueData}
                    salesReport={this.props.salesReport.lastRequestResponse}
                    uniqueClientsReport={this.props.uniqueClientsReport.lastRequestResponse}
                    stylistList={this.props.stylistList}
                  />
                  <ProductSales
                    startDate={moment(this.props.uniqueVisitsReport.start_date).format('D MMM YYYY')}
                    endDate={moment(this.props.uniqueVisitsReport.end_date).format('D MMM YYYY')}
                    productSales={this.props.productSalesReport}
                  />
                  <ProductSalesByStylist
                    startDate={moment(this.props.uniqueVisitsReport.start_date).format('D MMM YYYY')}
                    endDate={moment(this.props.uniqueVisitsReport.end_date).format('D MMM YYYY')}
                    productSalesByStylist={this.props.productSalesByStylistReport}
                  />
                </ComponentToPrint>
              </React.Fragment>
            )}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const {
    currentSalon: { id: salonId, stylistList },
    reports,
    clientCommunications: { clientList },
  } = state;
  const {
    salesReport,
    uniqueVisitsReport,
    rebookingReport,
    uniqueClientsReport,
    visitFrequencyReport,
    lastDatesSelected,
    appointmentsReport,
    productSalesReport,
    productSalesByStylistReport,
  } = reports;
  const currency = selectCurrentSalonCurrency(state);
  return {
    salonId,
    clientList,
    lastDatesSelected,
    salesReport,
    uniqueVisitsReport,
    rebookingReport,
    uniqueClientsReport,
    visitFrequencyReport,
    appointmentsReport,
    stylistList,
    productSalesReport,
    productSalesByStylistReport,
    currency,
  };
}

export default connect(mapStateToProps)(RetailLayout);
